export default __webpack_public_path__ + "static/media/bosyuu4_frame.896053b5.svg";